import { sa } from "./siteApiBase";
const siteApi = {
  site: {
    get: sa("GET site/{key}")
  },
  siteByOrgId: {
    get: sa("GET sitevalue/{key}")
  }
};
export default siteApi;
